import { render } from "./CommonHeader.vue?vue&type=template&id=1fde86da"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src882003474/src/vote-screen-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__